import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import type { FC } from "react";
interface FullLogoIconProps {
  className?: string;
  width?: number;
  height?: number;
}
export const FullLogoIcon: FC<FullLogoIconProps> = t0 => {
  const $ = _c(10);
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      width: t1,
      height: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const width = t1 === undefined ? 220 : t1;
  const height = t2 === undefined ? 168 : t2;
  let t3;
  if ($[5] !== className || $[6] !== height || $[7] !== props || $[8] !== width) {
    t3 = <Image src="/full-logo.svg" alt="Document Crunch" width={width} height={height} className={className} priority={true} {...props} />;
    $[5] = className;
    $[6] = height;
    $[7] = props;
    $[8] = width;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};